import { MulitpleFilter } from "./MultipleFilters";
import { SingleFilter } from "./SingleFilters/SingleFilter";
import "@assets/scss/input.scss";

export const Filters = ({ filterData, onChangeHandler, payload, isDisabled }) => {
  return <div>{filterData && Object.keys(filterData).length === 1 ? <SingleFilter isDisabled={isDisabled} filterData={filterData} onChangeHandler={onChangeHandler} payload={payload} /> : <MulitpleFilter isDisabled={isDisabled} filterData={filterData} onChangeHandler={onChangeHandler} payload={payload} />}</div>;
};
